import { PreIPODealsReducerStateType } from '@modules/pre-ipo-deals/pre-ipo-deals-section/types';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  offset: 0,
  limit: 25,
  search: '',
  order: 'desc',
  sortBy: 'startDate',
  clearPage: true,
  totalCount: 0
} as PreIPODealsReducerStateType;

export const preIPODealsClosedListStateReducerSlice = createSlice({
  name: 'preIPODealsClosedListStateReducer',
  initialState,
  reducers: {
    resetPreIPODealsClosedListStateReducerValues: state => ({
      ...state,
      offset: 0,
      limit: 25,
      search: '',
      order: 'desc',
      sortBy: 'startDate',
      totalCount: 0
    }),
    updatePreIPODealsClosedListStateReducerValues: (state, { payload }) => ({
      ...state,
      ...payload
    })
  }
});

export const {
  resetPreIPODealsClosedListStateReducerValues,
  updatePreIPODealsClosedListStateReducerValues
} = preIPODealsClosedListStateReducerSlice.actions;

export default preIPODealsClosedListStateReducerSlice.reducer;
